angular.module('aprima-core-ui')
    .directive('apAppointmentListItem', ['SettingService', '$rootScope', 'AppointmentTransitionToHelper', 'DateUtilities', 'AppointmentScheduleTypes',
        function (SettingService, $rootScope, AppointmentTransitionToHelper, DateUtilities, AppointmentScheduleTypes) {
        'use strict';

        return {
            restrict: 'EA',
            scope: {
                appt: '=',
                transitionType: '@',
                displayDateType: '@'
            },
            link: function(scope) {
                var settings = SettingService.getAppointmentsListSettings(),
                    displayEndTime = settings != null ? settings.displayEndTime : false, displayStartTime, displayDate;

                if(scope.displayDateType === 'Date'){
                    displayStartTime = false;
                    displayEndTime = false;
                    displayDate = true;
                }
                else{
                    displayStartTime = !displayEndTime;
                    displayDate = false;
                }

                var scheduleType = AppointmentScheduleTypes[scope.appt.ScheduleType];
                scope.isPatientVisit = scheduleType === AppointmentScheduleTypes.PatientVisit;
                scope.scheduleTypeDescription = scheduleType && scheduleType.name;

                if(scope.isPatientVisit) {
                    scope.appt.Age = DateUtilities.getPersonAgeAbbr(scope.appt.BirthDate);
                }

                scope.openAppointmentContextMenu = function openAppointmentContextMenu() {
                    $rootScope.setOptsForApptContextMenu({appointment: scope.appt});
                };

                scope.closeAppointmentContextMenu = function closeAppointmentContextMenu() {
                    $rootScope.setOptsForApptContextMenu(null);
                };

                scope.getTransition = function getTransition() {
                    return scope.appt.PatientId && scope.transitionType !== 'AppointmentDetails' ?
                        {appRoute: 'apptlistPatientDashboard', opts: {id: scope.appt.PatientId}} :
                        AppointmentTransitionToHelper.getTransition(scope.appt.ScheduleType, scope.appt.PatientId, null, false, scope.appt.Id);
                };

                scope.displayEndTime = displayEndTime;
                scope.displayStartTime = displayStartTime;
                scope.displayDate = displayDate;
            },
            template: '<ng-include src="getTemplateUrl()"/>',
            controller: function($scope){
                $scope.getTemplateUrl = function() {
                    return $scope.appt.dataType === 'template' ? 
                        '/core-ui/views/directives/partials/apAppointmentListTemplateSlot.html' :
                        '/core-ui/views/directives/partials/apAppointmentListItem.html';
                    };
            }
        };
    }]);
